function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "M7.65718 18.6736V8.42109H16.3429V18.6736C16.3429 18.9879 16.1022 19.1999 15.8572 19.1999H8.14289C7.89789 19.1999 7.65718 18.9879 7.65718 18.6736Z",
  stroke: "#0D53FC",
  strokeWidth: 1.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7143 4.52625V4.08415C13.7143 3.59582 13.3305 3.19995 12.8571 3.19995H11.1429C10.6695 3.19995 10.2857 3.59582 10.2857 4.08415V4.52625H6.42857C6.19188 4.52625 6 4.72418 6 4.96835V5.41045C6 5.65461 6.19188 5.85255 6.42857 5.85255H17.5714C17.8081 5.85255 18 5.65461 18 5.41045V4.96835C18 4.72418 17.8081 4.52625 17.5714 4.52625H13.7143Z",
  fill: "#0D53FC"
});

function SvgDeleteicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.669c39bf.svg";
export { ForwardRef as ReactComponent };